import {EditorContent, useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import {useEffect} from "react";
import Color from "@tiptap/extension-color";
import {Underline} from "@tiptap/extension-underline";
import TextStyle from "@tiptap/extension-text-style";
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import {Paragraph} from "@tiptap/extension-paragraph";

const TiptapView = ({ content, className, id }) => {
    const decodeHTML = (htmlString) => {
        if (!htmlString) return '';

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        let content = tempDiv.innerHTML;

        if (content.includes('&lt;') && content.includes('&gt;')) {
            content = content
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&amp;/g, '&')
                .replace(/&quot;/g, '"')
                .replace(/&#x27;/g, "'")
                .replace(/&#x2F;/g, '/');
        }

        return content;
    };

    const containsHTML = content && (
        content.includes('<table') ||
        content.includes('<div') ||
        content.includes('<p') ||
        content.includes('<span') ||
        content.includes('<br>') ||
        content.includes('<a') ||
        content.includes('&lt;table') ||
        content.includes('&lt;div') ||
        content.includes('&lt;p') ||
        content.includes('&lt;span')
    );

    const editor = useEditor({
        extensions: [
            StarterKit,
            Color,
            Underline,
            TextStyle,
            Paragraph,
            Link.configure({
                HTMLAttributes: {
                    class: 'link',
                },
            }),
            Table.configure({
                resizable: true,
            }),
            TableRow,
            TableHeader,
            TableCell,
        ],
        content: containsHTML ? '' : content,
        id: id,
        editable: false,
        parseOptions: {
            preserveWhitespace: 'full',
        }
    });

    useEffect(() => {
        if (editor && content && !containsHTML) {
            editor.commands.setContent(content, false);
        }
    }, [content, editor, containsHTML]);

    if (containsHTML) {
        const decodedContent = decodeHTML(content);

        return (
            <div
                className={`tiptap-view-html ${className || ""}`}
                id={id}
                dangerouslySetInnerHTML={{ __html: decodedContent }}
                />
        );
    }

    return <EditorContent editor={editor} className={className} id={id} />;
};

export default TiptapView;